export const CONSENT_TYPES = ["terms", "personal_data", "privacy_policy"];

export const logAuthConsents = ({ email, logUserConsent }) =>
  Promise.all(
    CONSENT_TYPES.map((consentType) => logUserConsent(email, consentType)),
  );
